import { put, call, select } from 'redux-saga/effects';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import {
  groupSignFileFailed,
  groupSignFileSuccessful, loadDocumentById,
} from '../actions';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import {
  addProgressLog, setProgressList, showProgressBar, signDocument,
} from '../../System/actions';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';
import { dateFormatter } from '../../../utils/formatters';
import { nameBySave } from '../../../utils/utils';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* groupSignFile(action) {
  try {
    const {
      payload: {
        cert,
        filter,
        selected = [],
      } = {},
    } = action;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/resources/documents/list-to-sign`; // todo это отдельный урл
    yield put(showProgressBar({
      title: 'Пакетное подписание документов',
      text: 'group.sign.file',
    }));
    yield put(addProgressLog({ log: 'Загрузка списка документов.' }));
    let list = selected;
    if (!selected || !selected.length) {
      const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
      if (dataResponse.status !== OK) {
        yield put(groupSignFileFailed([]));
        yield call(rejectActionPromise(action));
        yield put(addProgressLog({ log: '<span class=\'red-text\'>Список файлов не загружен.</span>', incError: true }));
      }
      list = yield dataResponse.json();
    }
    if (!list || !list.length) {
      yield put(addProgressLog({ log: 'Не найдены файлы для подписания.' }));
      throw new Error('Не найдены файлы для подписания.');
    }
    yield put(addProgressLog({ log: 'Список документов загружен.' }));
    yield put(setProgressList({ progressCount: list.length }));
    let stopSigned = false;
    for (let i = 0, len = list.length; i < len; i++) {
      stopSigned = yield select(getStop);
      if (stopSigned) {
        break;
      }
      const documentId = list[i];
      let name = '';
      try {
        const documentLoadPromise = yield put(loadDocumentById(documentId));
        const document = yield documentLoadPromise;
        if (!document) {
          yield put(addProgressLog({ log: `<span class='red-text'>Документ c ID «${documentId}» не найден.</span>`, incError: true }));
          continue;
        }
        const templateName = document && document.notification_template && document.notification_template.name
          ? document.notification_template.name
          : document.id;
        name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);
        const signaturePromise = yield put(signDocument({ cert, document }));
        const signatureDoc = yield signaturePromise;
        if (!signatureDoc || typeof signatureDoc === 'string') {
          throw new Error('Файл не подписан.');
        }
        yield put(addProgressLog({ log: `Файл «${name}» подписан.`, incSuccess: true }));
      } catch (e) {
        yield put(addProgressLog({ log: `<span class='red-text'>Файл ${name ? `«${name}» ` : ''}c ID «${documentId}» не подписан. ${typeof e === 'string' ? e : ''}</span>`, incError: true }));
      }
    }
    yield put(addProgressLog({ log: 'Подписание окончено.' }));
    if (!stopSigned) {
      yield put(groupSignFileSuccessful());
      yield call(resolveActionPromise(action, {}));
    }
  } catch (e) {
    yield put(groupSignFileFailed([]));
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
